import { useRouteError } from "react-router-dom"

export default function NotFound(){

    const error = useRouteError();
    console.log("route error", error);

    return (
        <>
        <h1>Oop! This page is - {error.statusText || error.message}</h1>
        </>
    )
}